
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.329 3h15.337C20.4 3 21 3.58 21 4.297v15.406C21 20.42 20.4 21 19.666 21H4.328C3.594 21 3 20.42 3 19.703V4.297C3 3.58 3.593 3 4.329 3zm1.578 5.122a1.548 1.548 0 102.191-2.19 1.548 1.548 0 00-2.19 2.19zm9.763 10.217h2.666v-4.715c0-2.313-.5-4.091-3.2-4.091-1.3 0-2.17.713-2.528 1.387h-.035V9.75h-2.56v8.589h2.666v-4.25c0-1.121.212-2.205 1.601-2.205 1.37 0 1.39 1.282 1.39 2.278v4.177zm-7.331 0H5.666V9.75H8.34v8.589h-.001z","fill":"#111"}})])
          )
        }
      }
    